var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createSlice } from '@reduxjs/toolkit';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import store from './store';
import { createDraft, finishDraft } from 'immer';
export const useCommonReducer = (reducerKey, initialState, inject = true) => {
    const dispatch = useDispatch();
    const value = useSelector((state) => state[reducerKey], shallowEqual);
    const dispatcher = useCallback((payload) => {
        if (typeof payload === 'function') {
            // eslint-disable-next-line
            const dispatchAction = () => {
                return (innerDispatcher, getState) => __awaiter(void 0, void 0, void 0, function* () {
                    const currentstate = getState()[reducerKey];
                    const draft = createDraft(currentstate);
                    yield Promise.resolve(payload(draft));
                    const result = finishDraft(draft);
                    innerDispatcher(store.slices[reducerKey].actions.Replace(result));
                });
            };
            dispatch(dispatchAction());
        }
        else {
            dispatch(store.slices[reducerKey].actions.Update(payload));
        }
    }, [dispatch, reducerKey]);
    if (!store.slices[reducerKey] && inject) {
        store.injectCommonReducer(reducerKey, initialState);
    }
    return [value || initialState, dispatcher];
};
export const useCommonDispatcher = () => {
    const dispatch = useDispatch();
    const dispatcher = useCallback((reducerKey, payload) => {
        if (typeof payload === 'function') {
            // eslint-disable-next-line
            const dispatchAction = () => {
                return (innerDispatcher, getState) => __awaiter(void 0, void 0, void 0, function* () {
                    const currentstate = getState()[reducerKey];
                    // TODO: Fix this promise issues
                    const draft = createDraft(currentstate);
                    yield Promise.resolve(payload(draft));
                    const result = finishDraft(draft);
                    innerDispatcher(store.slices[reducerKey].actions.Replace(result));
                });
            };
            dispatch(dispatchAction());
        }
        else {
            dispatch(store.slices[reducerKey].actions.Update(payload));
        }
    }, [dispatch]);
    return dispatcher;
};
export const useCreateSliceReducer = (slice) => {
    const dispatch = useDispatch();
    const dispatchActions = useMemo(() => {
        const actions = slice.actions;
        return Object.keys(actions).reduce((prevActions, actionKey) => (Object.assign(Object.assign({}, prevActions), { [actionKey]: (payload) => dispatch(actions[actionKey](payload)) })), {});
    }, [dispatch, slice.actions]);
    const value = useSelector((state) => state[slice.name], shallowEqual);
    if (!store.slices[slice.name]) {
        store.injectReducer(slice.name, slice);
    }
    const currentValue = useMemo(() => value || slice.getInitialState(), [slice, value]);
    return [currentValue, dispatchActions];
};
export const useSliceReducerActions = (slice) => {
    const dispatch = useDispatch();
    const dispatchActions = useMemo(() => {
        const actions = slice.actions;
        return Object.keys(actions).reduce((prevActions, actionKey) => (Object.assign(Object.assign({}, prevActions), { [actionKey]: (payload) => dispatch(actions[actionKey](payload)) })), {});
    }, [dispatch, slice.actions]);
    if (!store.slices[slice.name]) {
        store.injectReducer(slice.name, slice);
    }
    return dispatchActions;
};
export const useTestReducer = () => {
    const initialState = {
        name: 'TEST VALUE',
        count: 0,
    };
    return useCreateSliceReducer(createSlice({
        name: 'test',
        initialState,
        reducers: {
            setSlice: (state, payload) => {
                state.name = payload.payload;
            },
            setCounter: (state) => {
                state.count++;
            },
        },
    }));
};
